import React from 'react';
import './DetailModal.css';

const ConfirmModal = ({ title, message, onConfirm, onCancel }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="close-button" onClick={onCancel}>×</button>
        <h2 className="modal-title">{title}</h2>
        <div className="modal-body">
          <p>{message}</p>
          <div className="modal-actions">
            <button className="cancel-btn" onClick={onCancel}>
              Отмена
            </button>
            <button className="confirm-btn" onClick={onConfirm}>
              Подтвердить
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;